import { FormattedMessage } from 'react-intl';
import Button from '@mui/material/Button';
import { Order } from '../../models';

export interface CompletePaymentProps {
  order: Order;
}

export const CompletePayment = (props: CompletePaymentProps) => {
  const { order } = props;

  const completePayment = () => {
    // Use Stripe Checkout Session flow
    window.open(order.stripeInvoiceUrl, '_blank');
  };

  return (
    <Button
      id="complete-payment-btn"
      variant="contained"
      onClick={completePayment}
      sx={theme => ({
        height: theme.spacing(5),
        backgroundColor: '#5959EB',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#43509B',
        },
      })}
    >
      <FormattedMessage
        id="pending.order.complete.payment"
      />
    </Button>
  );
};
